import { render } from "./PairboardPage.vue?vue&type=template&id=96bf2d20"
import script from "./PairboardPage.vue?vue&type=script&lang=js"
export * from "./PairboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__